// ============================================================================
// src/shared/config/env.ts
// Configuración por entorno leída EXCLUSIVAMENTE del archivo .env (v2).
//
// CRA embebe en tiempo de build las variables con prefijo REACT_APP_ (accesibles
// vía process.env.REACT_APP_*). La config sale SOLO del .env: ya NO hay valores
// hardcodeados ni un config.json runtime (patrón v1, eliminado). Ver .env / .env.example.
//
// Si falta una variable REQUERIDA se lanza un error (fail-fast): así una mala
// configuración se detecta al arrancar, en vez de conectar en silencio a otro servidor.
// ============================================================================

const leerVar = (nombre: string, { requerida = false } = {}): string => {
  const valor = process.env[nombre];
  if (valor === undefined || valor === "") {
    if (requerida && process.env.NODE_ENV !== "test") {
      throw new Error(
        `[env] Falta la variable requerida ${nombre}. ` +
          `Configúrala en el archivo .env (ver .env.example).`
      );
    }
    return "";
  }
  return valor;
};

export const env = {
  // URL base del backend. Termina en "/". Las funciones api/ agregan la ruta ("api/...").
  apiBaseUrl: leerVar("REACT_APP_API_URL", { requerida: true }),
  // Clave AES compartida con el backend (cifrado de login/sesión).
  cryptoKey: leerVar("REACT_APP_CRYPTO_KEY", { requerida: true }),
  isDev: process.env.NODE_ENV !== "production",
};

export default env;
